var Module = {
    name: 'localization',
    default: 'en',
    misc: {
        data: {}
    },

    init: function () {
        Module.loadTranslations();
    },

    loadTranslations: function () {
        var translations;
        try {
            translations = require('../misc/lang/' + $(document).find('html').attr('lang'))
        } catch (e) {
            translations = require('../misc/lang/' + this.default)
        }

        Module.misc.data = translations
    },

    getTranslationsByKey: function (key) {
        return this.misc.data[key];
    }
}

Module.init();

module.exports = Module
